import api from './axios';

export const jobApi = {
  getJobs: (page = 0, size = 20) =>
    api.get(`/jobs?page=${page}&size=${size}`),

  searchJobs: (params) =>
    api.get('/jobs/search', {
      params,
      paramsSerializer: (p) => {
        const parts = [];
        Object.entries(p).forEach(([key, val]) => {
          if (val !== undefined && val !== null && val !== '') {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
          }
        });
        return parts.join('&');
      },
    }),

  getJob: (id) => api.get(`/jobs/${id}`),
  createJob: (data) => api.post('/jobs', data),
  updateJob: (id, data) => api.put(`/jobs/${id}`, data),
  deleteJob: (id) => api.delete(`/jobs/${id}`),
  closeJob: (id) => api.patch(`/jobs/${id}/close`),
  getMyJobs: (page = 0) => api.get(`/jobs/my?page=${page}`),
  repostJob: (id) => api.post(`/jobs/${id}/repost`),
  getSimilarJobs: (id) => api.get(`/jobs/${id}/similar`),
  getJobsByIds: (ids) => api.post('/jobs/batch', ids),
};

export const applicationApi = {
  apply: (jobPostId, data) => api.post(`/applications/jobs/${jobPostId}`, data),
  getMyApplications: (page = 0) => api.get(`/applications/my?page=${page}`),
  getJobApplications: (jobPostId, page = 0) => api.get(`/applications/jobs/${jobPostId}?page=${page}`),
  updateStatus: (id, status) => api.put(`/applications/${id}/status?status=${status}`),
  withdraw: (id) => api.delete(`/applications/${id}`),
};

export const bookmarkApi = {
  toggle: (jobPostId) => api.post(`/bookmarks/jobs/${jobPostId}`),
  getMyBookmarks: (page = 0) => api.get(`/bookmarks?page=${page}`),
};

export const authApi = {
  getLoginUrls: () => api.get('/auth/login-urls'),
  getMe: () => api.get('/users/me'),
  updateMe: (data) => api.put('/users/me', data),
  updateRole: (role) => api.put(`/users/me/role?role=${role}`),
};

export const notificationApi = {
  getUnreadCount: () => api.get('/notifications/unread-count'),
  getNotifications: () => api.get('/notifications'),
  markAsRead: (id) => api.patch(`/notifications/${id}/read`),
};

export const resumeApi = {
  getMyResumes: () => api.get('/resumes'),
  getResume: (id) => api.get(`/resumes/${id}`),
  create: (data) => api.post('/resumes', data),
  update: (id, data) => api.put(`/resumes/${id}`, data),
  delete: (id) => api.delete(`/resumes/${id}`),
  setDefault: (id) => api.patch(`/resumes/${id}/default`),
};
